(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tt-fitting-check"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tt-fitting-check')) {
  customElements.define('tt-fitting-check', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const input = this.querySelector('input');
      const result = this.querySelector('[role="status"]');
      const button = this.querySelector('button');
      const buttonText = button.textContent;
      const reset = () => {
        clearTimeout(this.checkTimer);
        this.checkTimer = null;
        button.disabled = false;
        button.textContent = buttonText;
        button.removeAttribute('aria-busy');
      };
      this.resetCheck = reset;
      const check = () => {
        if (this.checkTimer) return;
        reset();
        const value = input.value.toUpperCase().replace(/\s/g, '');
        const areas = 'AB AL B BA BB BD BH BL BN BR BS BT CA CB CF CH CM CO CR CT CV CW DA DD DE DG DH DL DN DT DY E EC EH EN EX FK FY G GL GU HA HD HG HP HR HS HU HX IG IP IV KA KT KW KY L LA LD LE LL LN LS LU M ME MK ML N NE NG NN NP NR NW OL OX PA PE PH PL PO PR RG RH RM S SA SE SG SK SL SM SN SO SP SR SS ST SW SY TA TD TF TN TQ TR TS TW UB W WA WC WD WF WN WR WS WV YO ZE'.split(' ');
        const area = (value.match(/^[A-Z]+/) || [''])[0];
        const valid = /^[A-Z]{1,2}[0-9][A-Z0-9]?[0-9][ABD-HJLNP-UW-Z]{2}$/.test(value) && areas.includes(area);
        input.setAttribute('aria-invalid', String(!valid));
        if (!valid) {
          result.dataset.state = 'error';
          result.textContent = this.dataset.error;
          return;
        }
        input.value = value.slice(0, -3) + ' ' + value.slice(-3);
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = this.dataset.checking;
        result.dataset.state = 'checking';
        result.textContent = this.dataset.checking;
        this.checkTimer = setTimeout(() => {
          reset();
          if (!this.isConnected || input.value.toUpperCase().replace(/\s/g, '') !== value) return;
          result.dataset.state = 'success';
          result.textContent = '✓ ' + this.dataset.success;
        }, 850);
      };
      this.querySelector('button').addEventListener('click', check);
      input.addEventListener('keydown', event => { if (event.key === 'Enter') { event.preventDefault(); event.stopPropagation(); check(); } });
      input.addEventListener('input', () => { reset(); result.textContent = ''; delete result.dataset.state; input.removeAttribute('aria-invalid'); });
    }
    disconnectedCallback() {
      this.resetCheck?.();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
